
const digest = 'dc29a4e1b8df881d3eda4e295f90cbc60bb732dfcfbd35e22e41c52bd2177bdd';
const classes = {"wrapper":"_wrapper_1xdvc_1"};
const css = `._wrapper_1xdvc_1 {
  height: 100%;
  background: #ffffff;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  